import { useTheme } from "app/shared";
import { FC } from "react";
import styles from "./NFTWidget.module.scss";

export interface NFTCard {
  title: string;
  image: string;
}

interface NFTWidgetProps {
  nfts?: NFTCard[];
}

const NFTWidget: FC<NFTWidgetProps> = ({ nfts }) => {
  const { theme } = useTheme();

  return (
    <div
      className={`${styles.container} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h3
        className={`${styles.title} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      >
        My NFTs
      </h3>
      {!nfts || nfts.length === 0 ? (
        <div className={styles.noData}>You don't own any NFTs yet.</div>
      ) : (
        <div className={styles.cardsContainer}>
          {nfts.map((nft, index) => (
            <div
              key={index}
              className={`${styles.card} ${
                theme === "dark" ? styles.darkTheme : ""
              }`}
            >
              <img src={nft.image} alt={nft.title} className={styles.image} />
              <p
                className={`${styles.cardTitle} ${
                  theme === "dark" ? styles.darkTheme : ""
                }`}
              >
                {nft.title}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NFTWidget;
